<template>
    <main class="mt-0 main-content">
        <section>
            <div class="page-header min-vh-100">
                <div class="container">
                    <div class="row">
                        <div class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0">
                            <div class="card card-plain">
                                <div class="pb-0 card-header text-start">
                                    <h4 class="font-weight-bolder">META</h4>
                                    <p class="mb-0">Restablecer contraseña.</p>
                                </div>
                                <argon-alert v-if="showAlertFail" color="danger" :dismissible="true" @close-alert="closeAlertFail">
                                    Las contraseñas no coinciden
                                </argon-alert>
                                <div class="card-body">
                                    <form @submit.prevent="onSubmit" role="form">
                                        <div>
                                            <label for="password">Nueva contraseña:</label>
                                            <argon-input v-model="userForm.password" type="password"
                                                placeholder="New Password" name="password" size="lg" />
                                        </div>
                                        <div>
                                            <label for="confirm-password">Confirmar contraseña:</label>
                                            <argon-input v-model="userForm.confirmPassword" type="password"
                                                placeholder="Confirm new Password" name="password" size="lg" />
                                        </div>
                                        <div class="text-center">
                                            <argon-button type="submit" class="mt-4" variant="gradient" color="primary"
                                                fullWidth size="lg">
                                                Restablecer contraseña
                                            </argon-button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div
                            class="top-0 my-auto text-center col-6 d-lg-flex d-none h-100 pe-0 position-absolute end-0 justify-content-center flex-column">
                            <div class="position-relative bg-gradient-primary h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
                                style="background-image: url('https://www.libramientoslp.mx/images/bgContacto.png');
                      background-size: cover;">
                                <span class="mask bg-gradient-primary opacity-6"></span>
                                <h1 class="mt-5 text-white font-weight-bolder position-relative">"META"</h1>
                                <h4 class="text-white position-relative">
                                    Mexicana de Técnicos en Autopistas
                                </h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
</template>
  
<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import ArgonAlert from '@/components/ArgonAlert.vue';
const body = document.getElementsByTagName("body")[0];

export default {
    name: "Forgot",
    props: ['resetPasswordToken'],
    components: {
        ArgonInput,
        ArgonButton,
        ArgonAlert,
    },
    data() {
        return {
            showAlertFail: false,
            userForm: {
                password: '',
                confirmPassword: ''
            },
        };
    },
    methods: {
        onSubmit() {
            if(this.userForm.password === this.userForm.confirmPassword){
                // Enviar solicitud de recuperación de contraseña a la API de Rails
                // utilizando axios u otra librería similar.
                this.plain
                    .post(`/reset_password`, {
                        password: this.userForm.password,
                        token: this.resetPasswordToken
                    })
                    .then((response) => {
                        console.log(response)
                        this.$swal.fire({
                            icon: 'success',
                            title: 'Listo',
                            text: 'Se ha reestablecido tu contraseña',
                            confirmButtonColor: '#3085d6',
                            confirmButtonText: 'Iniciar sesion'
                        })
                        .then((result) => {
                            console.log(result)
                            if(result.isConfirmed)
                                this.$router.replace({ path: '/signin'})
                        })
                    })
                    .catch((error) => {
                        console.log("Error al olvidar contrasena", error);
                    });
            } else {
                this.showAlertFail = true
            }
        },
        closeAlertFail(){
            this.showAlertFail = false
        },
    },
    created() {
        this.$store.state.hideConfigButton = true;
        this.$store.state.showNavbar = false;
        this.$store.state.showSidenav = false;
        this.$store.state.showFooter = false;
        body.classList.remove("bg-gray-100");
    },
};
</script>